/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchPhotoListItem
 */
export interface MatchPhotoListItem {
    /**
     * 
     * @type {string}
     * @memberof MatchPhotoListItem
     */
    id: string;
    /**
     * Backend /assets/pipe URL for the stored screenshot (reliable across environments)
     * @type {string}
     * @memberof MatchPhotoListItem
     */
    assetUrl?: string;
    /**
     * User id that uploaded the screenshot
     * @type {string}
     * @memberof MatchPhotoListItem
     */
    uploadedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchPhotoListItem
     */
    uploadedAt: number;
}

/**
 * Check if a given object implements the MatchPhotoListItem interface.
 */
export function instanceOfMatchPhotoListItem(value: object): value is MatchPhotoListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('uploadedAt' in value) || value['uploadedAt'] === undefined) return false;
    return true;
}

export function MatchPhotoListItemFromJSON(json: any): MatchPhotoListItem {
    return MatchPhotoListItemFromJSONTyped(json, false);
}

export function MatchPhotoListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchPhotoListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetUrl': json['assetUrl'] == null ? undefined : json['assetUrl'],
        'uploadedBy': json['uploadedBy'] == null ? undefined : json['uploadedBy'],
        'uploadedAt': json['uploadedAt'],
    };
}

export function MatchPhotoListItemToJSON(json: any): MatchPhotoListItem {
    return MatchPhotoListItemToJSONTyped(json, false);
}

export function MatchPhotoListItemToJSONTyped(value?: MatchPhotoListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetUrl': value['assetUrl'],
        'uploadedBy': value['uploadedBy'],
        'uploadedAt': value['uploadedAt'],
    };
}

